"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboTag = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ComboTag = ({ id, className, primaryContent, secondaryContent }) => {
    const comboTagClassName = classnames_1.default('bds-c-combo-tag', className);
    return (react_1.default.createElement("div", { id: id, className: comboTagClassName },
        react_1.default.createElement("div", { className: 'bds-c-combo-tag__primary-content' }, primaryContent),
        secondaryContent ? (react_1.default.createElement("div", { className: 'bds-c-combo-tag__secondary-content' }, secondaryContent)) : null));
};
exports.ComboTag = ComboTag;
exports.default = exports.ComboTag;
